import { Component } from "react";
import { Form, Transfer } from "antd";
import { getLangList } from '@/lib/i18n';
import { dateTimeFormat4, getMoment } from "@/lib/dateTime";
import { modalFromLayout } from "@/lib/antdElementFunction";

interface props {
  form?: any;
  dataArray: any;
}

interface state {
  scheduleArray: Array<object>;
  targetKeyArray: string[];
}

class ModalBatchDelete extends Component<props, state> {
  state = {
    scheduleArray: [],
    targetKeyArray: [],
  };
  busT: any = getLangList("bus");

  componentDidMount() {
    this.initStudentData();
  }

  initStudentData = () => {
    const { dataArray } = this.props;

    const scheduleArray = dataArray
      .filter((item: any) => item.title)
      .map((item: any) => ({
        key: `${item.id}`,
        title: `${item.title} (${getMoment(item.startTime).format(dateTimeFormat4)})`,
      }));

    this.setState({ scheduleArray });
  }

  onChangeSchedule = (targetKeys: any) => {
    this.setState({ targetKeyArray: targetKeys });
  }

  render() {
    const { form } = this.props;
    const { scheduleArray, targetKeyArray } = this.state;

    return (
      <Form
        className="admin-form"
        style={{ marginTop: 20 }}
        {...modalFromLayout}
        form={form}
        initialValues={{
          idArray: [],
        }}
      >
        <Form.Item label={this.busT.TAKE_BUS_LIST} name="idArray">
          <Transfer
            dataSource={scheduleArray}
            showSearch
            filterOption={(inputValue: any, option: any) => option.title.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0}
            listStyle={{ width: 250, height: 300 }}
            targetKeys={targetKeyArray}
            onChange={this.onChangeSchedule}
            render={item => item.title}
          />
        </Form.Item>
      </Form >
    );
  }
}

export default ModalBatchDelete;